import React from "react";
import styled, { keyframes } from "styled-components";

import Header from "../Header/Header";
import Footer from "../Footer/Footer";

const MainContainer = ({ children }) => {
  return (
    <Container>
      <Header />
      <Content>{children}</Content>
      <Footer />
    </Container>
  );
};

export default MainContainer;

// Jednostavna content animacija
const contentFadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

const Content = styled.div`
  padding-top: 74px;
  min-height: calc(100dvh - 467px);
  height: 100%;
  /* Jednostavna i brza animacija */
  opacity: 0;
  animation: ${contentFadeIn} 0.4s ease-out forwards;
  animation-delay: 0.1s;

  @media (max-width: 1200px) {
    min-height: calc(100dvh - 430.22px);

    padding-top: 64px;
  }

  @media (max-width: 768px) {
    padding-top: 56px;
    animation-duration: 0.3s;
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    opacity: 1;
  }
`;
